const rankingItems = [
  { rank: 1, title: '星际穿越2', type: '电影', heat: '98.6', trend: 'up', tag: '热映' },
  { rank: 2, title: '长安十二时辰', type: '电视剧', heat: '96.2', trend: 'up', tag: '热播' },
  { rank: 3, title: '了不起的挑战 第五季', type: '综艺', heat: '93.8', trend: 'stable', tag: '热门' },
  { rank: 4, title: '鬼灭之刃 柱训练篇', type: '动漫', heat: '91.5', trend: 'up', tag: '新番' },
  { rank: 5, title: '地球脉动III', type: '纪录片', heat: '89.7', trend: 'up', tag: '高分' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="text-center mb-10">
          <p className="text-xs md:text-sm font-medium text-accent-500 uppercase tracking-wide mb-2">热播榜单</p>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">热播榜单</h2>
          <p className="mt-2 text-sm text-foreground-500">全网实时热度排名，大家都在看</p>
        </div>

        <div className="max-w-[700px] mx-auto space-y-3">
          {rankingItems.map((item, idx) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer group"
            >
              <div className={`w-9 h-9 rounded-lg flex items-center justify-center font-bold text-sm shrink-0 ${
                item.rank === 1 ? 'bg-accent-500 text-background-50' :
                item.rank === 2 ? 'bg-secondary-500 text-background-50' :
                item.rank === 3 ? 'bg-primary-400 text-background-50' :
                'bg-background-300 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 truncate">{item.title}</h3>
                  <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-primary-100/60 text-primary-600 whitespace-nowrap">{item.tag}</span>
                </div>
                <p className="text-xs text-foreground-400 mt-0.5">{item.type}</p>
              </div>

              <div className="flex items-center gap-1 shrink-0">
                {item.trend === 'up' && <i className="ri-arrow-up-line text-accent-500 text-sm"></i>}
                {item.trend === 'stable' && <i className="ri-subtract-line text-foreground-400 text-sm"></i>}
                <span className="text-sm font-medium text-accent-600">{item.heat}</span>
                <span className="text-[10px] text-foreground-400">热度</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}